export default __webpack_public_path__ + "static/media/testador3.53728268.png";